define(['app', './base'], function (app, Helper) {
  return Helper.extend({
    switchClass: function () {
      this.$el.children().toggleClass('is-hidden is-active')
    },

    initialize: function () {
      var self = this

      this.$el.on('click', function () {
        self.switchClass()
      })
    }
  })
})
